module.exports = __webpack_public_path__ + "img/weekreportbg.0b10000c.png";